import type { TimelineItem } from "@/types";

export default function Timeline({ items }: { items: TimelineItem[] }) {
  return (
    <ol className="relative pl-6">
      <span className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300" aria-hidden="true"></span>
      {items.map((item) => (
        <li key={item.time} className="relative pb-6 last:pb-0">
          <span className="absolute -left-6 top-1 w-3.5 h-3.5 rounded-full border-2 border-primary-500 bg-background-50"></span>
          <p className="font-mono-num text-[11px] text-primary-600">{item.time}</p>
          <p className="mt-1 text-sm text-foreground-700 leading-relaxed">{item.event}</p>
        </li>
      ))}
    </ol>
  );
}